import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import HomeCardBannerImage from './HomeCardBannerImage';
import './HomeCardBannerFront.scss';

const HomeCardBannerFront = ({ bannerName, isWebView }) => {
  const renderContent = () =>
    isWebView && (
      <div className="home-card-banner-front__content">
        <div className="home-card-banner-front__title">
          {trans(`homecard.banner.${bannerName}.title`)}
        </div>
      </div>
    );

  const renderLabels = () => (
    <React.Fragment>
      <div className="home-card-banner-front__label">
        {trans(`homecard.banner.${bannerName}.label`)}
      </div>
      {!isWebView && (
        <div className="home-card-banner-front__title--mobile">
          {trans(`homecard.banner.${bannerName}.title`)}
        </div>
      )}
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <HomeCardBannerImage bannerName={bannerName} isWebView={isWebView}>
        {renderLabels()}
      </HomeCardBannerImage>
      {renderContent()}
    </React.Fragment>
  );
};

HomeCardBannerFront.propTypes = {
  bannerName: PropTypes.string,
  isWebView: PropTypes.bool
};

HomeCardBannerFront.defaultProps = {
  bannerName: '',
  isWebView: true
};

export default HomeCardBannerFront;
